import React from "react";
import PageLayout from "@/components/layout/PageLayout";
import PageHero from "@/components/PageHero";
import Seo from "@/components/Seo";

/**
 * Generic legal/policy page renderer.
 * Pass sections=[{heading, paragraphs:[string]}].
 */
export default function LegalPage({ title, eyebrow, intro, sections = [], lastUpdated = "February 23, 2026", seoDesc }) {
  return (
    <PageLayout>
      <Seo title={title} description={seoDesc || intro?.slice(0, 160)} />
      <PageHero
        eyebrow={eyebrow || "Legal"}
        title={title}
        subtitle={`Last updated: ${lastUpdated}`}
        image="https://images.pexels.com/photos/37667517/pexels-photo-37667517.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=1920"
      />
      <section className="py-16 bg-cream-50">
        <div className="container-tti max-w-3xl">
          {intro && (
            <p className="text-base leading-relaxed text-foreground/85 mb-10 font-light italic border-l-2 border-saffron pl-4">
              {intro}
            </p>
          )}
          <div className="space-y-10" data-testid="legal-content">
            {sections.map((s, i) => (
              <section key={i} data-testid={`legal-section-${i}`}>
                <h2 className="font-serif text-2xl text-deepred mb-3">{s.heading}</h2>
                <div className="space-y-3 text-sm leading-relaxed text-foreground/80 font-light">
                  {s.paragraphs.map((p, j) => (
                    <p key={j}>{p}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>
          <div className="mt-16 pt-8 border-t border-cream-200 text-xs text-foreground/60">
            For questions about this policy, email{" "}
            <a href="mailto:info@ttiholidays.com" className="text-saffron hover:underline">
              info@ttiholidays.com
            </a>{" "}
            or WhatsApp{" "}
            <a href="https://wa.me/917017798524" target="_blank" rel="noopener noreferrer" className="text-saffron hover:underline">
              +91 70177 98524
            </a>.
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
